import React, { useState } from "react";

import BadgeChip from "components/Badge";
import HomeImage from "components/HomeImage";

import { createStyles, Group, Container, Stack } from "@mantine/core";

import { motion } from "framer-motion";

const useStyles = createStyles((theme) => ({
  big: {
    fontSize: "108px",
    fontFamily: "Roboto, sans-serif",
    fontWeight: "bolder",
  },
  btn: {
    top: 0,
    left: 0,
    transition: "all .15s linear 0s",
    position: "relative",
    display: "inline-block",
    padding: "15px 25px",
    backgroundColor: "white",
    border: "2px solid black",

    textTransform: "uppercase",
    fontWeight: "bolder",
    color: "black",
    letterSpacing: "1px",

    boxShadow: "6px 6px 0 black",
    textDecoration: "none",

    "&:hover": {
      backgroundColor: "#FAEBD7",
      cursor: "pointer",
    },

    "&:active": {
      top: "3px",
      left: "3px",
      boxShadow: "3px 3px 0 black",
    },

    "&::after": {
      top: "1px",
      left: "-2px",
      width: "50px",
      height: "20px",
    },

    "&::before": {
      bottom: "-2px",
      right: "1px",
      width: "50px",
      height: "20px",
    },
  },
  chips: {
    pointerEvents: "none",
  },
  bio: {
    margin: "0 0 10px 5px",
  },
  container: {
    height: "65%",
    display: "flex",
    alignItems: "center",
    marginTop: "50px",
    minHeight: "700px",

    [theme.fn.smallerThan(768)]: {
      minHeight: "1000px",
    },

    [theme.fn.smallerThan(590)]: {
      minHeight: "1200px",
    },
    [theme.fn.smallerThan(490)]: {
      minHeight: "1300px",
    },
  },
  center: {
    display: "flex",
    alignItems: "center",
  },
  halfThenWhole: {
    width: "50%",

    [theme.fn.smallerThan(768)]: {
      width: "100%",
    },
  },
  disappear: {
    [theme.fn.smallerThan(1350)]: {
      display: "none",
    },
  },
  btnContainer: {
    [theme.fn.smallerThan(768)]: {
      display: "flex",
      justifyContent: "center",
    },
  },
  imgContainer: {
    display: "flex",
    gap: "3px",
  },
  grid: {
    display: "flex",
    gap: "50px",

    [theme.fn.smallerThan(768)]: {
      flexDirection: "column",
    },
  },
}));

const Home = () => {
  const { classes, cx } = useStyles();

  const [loading, setLoading] = useState(true);

  const labels = ["Front-End Engineer", "Stanford Graduate", "Swimmer"];
  const imgNames = ["p1", "p2", "p3"];

  const clickExplore = () => {
    document?.getElementById("projects")?.scrollIntoView({
      behavior: "smooth",
    });
  };

  return (
    <div className={classes.container}>
      <Container size="xl">
        <div className={classes.grid}>
          <div className={cx(classes.center, classes.halfThenWhole)}>
            <Stack>
              <div className={classes.big}>Hi I'm Ben.</div>
              <Group className={classes.chips}>
                {labels.map((label) => (
                  <span key={label}>
                    <BadgeChip label={label} />
                  </span>
                ))}
              </Group>
              <div className={classes.bio}>
                Software engineer living in San Francisco with 3 years of experience
                developing applications in React and TypeScript. Graduated from Stanford University in 2020. Passionate
                about designing and creating enjoyable user experiences.
                Currently working at a startup connecting clients with expert
                networks.
              </div>
              <div className={classes.btnContainer}>
                <button onClick={clickExplore} className={classes.btn}>
                  Explore
                </button>
              </div>
            </Stack>
          </div>
          <div className={classes.halfThenWhole}>
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 3 }}
              className={classes.imgContainer}
            >
              {imgNames.map((imgName) => (
                <div key={imgName}>
                  <HomeImage
                    loading={loading}
                    setLoading={setLoading}
                    imgName={imgName}
                  />
                </div>
              ))}
            </motion.div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Home;
